/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { niveauDeclaration, niveauDeclarationV2 } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_031: Question = {
  id: 'pres-031-declaration-especes-statut',
  oldId: '45',
  title: 'Déclaration des espèces à statut présentes sur le territoire',
  number: '3.15',
  description: ['Les occurrences connues d’espèces à statut présentes sur le territoire ont été déclarées au Centre des données du patrimoine naturel du Québec qu’elles aient été identifiées par les employés de l’organisation municipale, ou fournies par les citoyens ou les contracteurs'],
  type: QuestionType.ACTIVITY,
  frequency: 1,
  idEM: 4,
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      scoringFct: (data: string[]) => parseFloat(data[0]),
      score: '0',
      labels: ['non déclarées', 'partiellement', 'toutes déclarées'],
      maxScore: 1,
      help: niveauDeclaration,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

const question_pres_031__v3: Question = {
  ...question_pres_031,
  title: 'Déclaration des espèces en situation précaire présentes sur le territoire',
  number: '3.5',
  slots: [
    {
      ...question_pres_031.slots[0],
      labels: ['non déclaré', 'toutes déclarées / partiellement déclarées'],
      help: niveauDeclarationV2,
    },
  ],
};

export const question_pres_031_v2: Question = question_pres_031;
export const question_pres_031_v3: Question = question_pres_031__v3;
